import React from "react";

const ShareVotes = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" 
    // xmlns:xlink="http://www.w3.org/1999/xlink" 
    width="50"
    height="50" x="0" y="0" 
    viewBox="0 0 600 500" 
    // style={{ enableBackground: "new 0 0 50 50" }}
    // xml:space="preserve" 
    className="share-votes-icon">
      <g>
        <path d="M494.533 172.016 378.634 56.117c-9.563-9.563-19.263-14.412-28.829-14.412-13.135 0-28.472 9.99-28.472 38.146v39.457c-84.204 3.67-162.839 38.203-222.815 98.176C34.994 281.004.006 365.459 0 455.293a15 15 0 0 0 26.992 9.01c70.819-94.266 177.439-149.975 294.341-154.373v38.85c0 28.154 15.337 38.146 28.471 38.146h.003c9.565 0 19.265-4.849 28.827-14.411l115.898-115.901C505.797 245.353 512 230.331 512 214.315c0-16.013-6.203-31.036-17.467-42.299z" fill="#ffffff" opacity="1" data-original="#000000" className="">

        </path>
      </g>
    </svg>
  );
};

export default ShareVotes;
